<div class="layout-wrapper layout-static" [ngClass]="containerClass">
    <app-home-topbar></app-home-topbar>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <div class="layout-mask animate-fadein"></div>
</div>